import DOMPurify from "dompurify";
import { marked } from "marked";
import { type FC, useEffect, useState } from "react";

import style from "./Markdown.module.css";

export interface MarkdownFilePreviewProps {
  markdownText: string;
  baseUrl: string;
}

export const MarkdownPreview: FC<MarkdownFilePreviewProps> = ({ markdownText = "", baseUrl = "" }) => {
  const [markdownHTML, setMarkdownHTML] = useState<string>("");

  useEffect(() => {
    const handleAfterSanitizeAttributes = (node: Element) => {
      // set all elements owning target to target=_blank
      if ("target" in node) {
        node.setAttribute("target", "_blank");
        node.setAttribute("rel", "noopener");
      }

      if (node.tagName === "IMG" && "src" in node) {
        const src = node.getAttribute("src");

        // relative path, add base path to it
        if (src?.startsWith("/") && !src.startsWith(baseUrl)) {
          node.setAttribute("src", baseUrl + src.slice(1));
        }
      }
    };

    DOMPurify.addHook("afterSanitizeAttributes", handleAfterSanitizeAttributes);

    setMarkdownHTML(DOMPurify.sanitize(marked.parse(markdownText) as string));

    return () => {
      DOMPurify.removeHook("afterSanitizeAttributes", handleAfterSanitizeAttributes);
    };
  }, [baseUrl, markdownText]);

  return <div dangerouslySetInnerHTML={{ __html: markdownHTML }} className={style.markdown} />;
};
